<template>
  <secondary-data-tab data-type="Transaction" :filter="filter" :active="active" />
</template>

<script>
  import SecondaryDataTab from './SecondaryDataTab';
	export default {
		name: 'TransactionsTab',
    components: {SecondaryDataTab},
    props: {filter: Object, active: Boolean}
  };
</script>
